import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { API, useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Check, Loader2 } from "lucide-react";

export default function PaymentSuccessPage() {
  const location = useLocation();
  const nav = useNavigate();
  const { checkAuth } = useAuth();
  const [status, setStatus] = useState("checking");
  const params = new URLSearchParams(location.search);
  const sessionId = params.get("session_id");

  useEffect(() => {
    if (!sessionId) { nav("/"); return; }
    let tries = 0;
    const poll = async () => {
      tries++;
      try {
        const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          await checkAuth();
          setStatus("paid");
          return;
        }
      } catch {}
      if (tries < 10) setTimeout(poll, 1500);
      else setStatus("timeout");
    };
    poll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="max-w-md text-center">
        {status === "checking" && (
          <>
            <Loader2 className="mx-auto animate-spin" size={32}/>
            <h1 className="font-display text-3xl font-black mt-4">Setting the type…</h1>
            <p className="text-sm text-muted-foreground mt-2">Confirming your subscription with Stripe.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <div className="w-16 h-16 rounded-full bg-[hsl(var(--paid-bg))] border-2 border-[hsl(var(--paid-border))] flex items-center justify-center mx-auto">
              <Check size={30} className="text-[hsl(var(--paid-text))]"/>
            </div>
            <h1 className="font-display text-4xl font-black mt-4">Welcome to Premium.</h1>
            <p className="text-sm text-muted-foreground mt-2">Unlimited bills, forecast, PDF export, and no ads — all unlocked.</p>
            <Button className="mt-6" onClick={()=>nav("/calendar")} data-testid="post-checkout-continue">Open the ledger</Button>
          </>
        )}
        {status === "timeout" && (
          <>
            <h1 className="font-display text-3xl font-black">Still confirming…</h1>
            <p className="text-sm text-muted-foreground mt-2">Stripe is taking a moment. Refresh in a bit — your account will update automatically.</p>
            <Button className="mt-6" onClick={()=>nav("/pricing")}>Back to pricing</Button>
          </>
        )}
      </div>
    </div>
  );
}
